import 'react-tabulator/lib/styles.css'; 
import "react-tabulator/lib/css/bootstrap/tabulator_bootstrap4.min.css";
import '../../resources/css/dashboard/HoodList.scss';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ReactTabulator, reactFormatter } from 'react-tabulator';
import { Row } from 'react-bootstrap';
import ReactExport from "react-data-export";
import moment from 'moment';
import { initModalCallback } from '../../actions/index';
import FilterSearch from '../common/FilterSearch';
import ListSettingBtn from '../common/ListSettingBtn';
import CommonListFooter from '../common/CommonListFooter';
import { updateMaxPageNumber, keepTableInfoToSession, getTableInfoFromSession, reloadTable, groupMenuTitleFormatter, commonListFooter } from '../common/access-list';
import { getDeviceDetail, forwardDashboard, initDevicesData, removeDevice } from '../../actions/dashboard/index';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

let viewRow, editRow, deleteRow;

const OnlineIcon = (props) => {
  const cellData = props.cell._cell.row.data;
  let classIcon;

  if (cellData.isOnline === 1) {
    classIcon = 'icon-online';
  } else {
    classIcon = 'icon-offline';
  }

  return (
    <span className='area-status-icon'>
      <span className={classIcon} />
    </span>      
  );
};

const GroupBtnsMenu = (props) => {
  if (viewRow && editRow && deleteRow) {
    // const cellData = props.cell._cell.row.data;
    return (
      <div className='group-buttons-menu'>
          <span className='operation-button-area'>
            <span className='btn-area'><span className='icon-btn-info' onClick={() => viewRow(props)}/></span>
            <span className='btn-area'><span className='icon-btn-edit2' onClick={() => editRow(props)}/></span>
            <span className='btn-area'><span className='icon-btn-remove' onClick={() => deleteRow(props)}/></span>
          </span>
          <span className='more-button-area'>
            <span className='btn-area'><span className='icon-btn-more-dark'/></span>
          </span>
      </div>
    );
  } else {
    return (
      <div className='group-buttons-menu'>
      </div>
    );
  }
};

class HoodList extends Component {
  tableId = 'hoodList'
  refFilterSearch = null
  refListCommonFooter = null
  // set this state for re-fresh sub component
  state = {
    refTable: null,
    isInitComplete: false,
    numberPerPagerValue: 50,
    filterColumns: [
      { title: "Model Number", field: "modelName" },
      { title: "Serial Number", field: "SN" }
    ],
    sessionKey: 'RangeHood.HoodListParams',
    /**
     *  quickSearchFilter is array
     *  title is menu tile
     *  filters is menu items
     *  filter: name and field to make the id, and checked is default checked or not.
     *          value and field will into filter for table
     */
    quickSearchFilter : [{
      title: 'Status',
      filter: [
        { name:'online', title: 'Online', field: 'isOnline', type:"like", value: '1', checked: true },
        { name:'offline', title: 'Offline', field: 'isOnline', type:"like", value: '0', checked: true }, 
      ]
    }],

    /**
     *  visibleColumnsConfig is array
     *  title is menu tile
     *  columns is all changed visible columns for table list to display
     */
    visibleColumnsConfig : {
      title: 'Visible Columns',
      // columns name is for dom element id
      columns: [
        { name:'modelName', title: "Model Number", field: "modelName" },
        { name:'sn', title: "Serial Number", field: "SN" },
        { name:'mac', title: "MAC", field: "MAC" },
        { name:'country', title: "Country", field: "countryLong" },
        { name:'state', title: "State", field: "stateLong" },
        { name:'city', title: "City", field: "cityLong" },
        { name:'longitude', title: "Longitude", field: "longitude" },
        { name:'latitude', title: "Latitude", field: "latitude" },
        { name:'laborWarranty', title: "Labor Warranty", field: "laborWarranty" },
        { name:'partsWarranty', title: "Parts Warranty", field: "partsWarranty" },
        { name:'registeredDate', title: "Registered First Date", field: "registeredDate" },
        { name:'status', title: "Status", field: "isOnline" }
      ]
    }
  }

  constructor(props) {
    super(props);

    // bind this props to function
    this.dataLoading = this.dataLoading.bind(this);
    viewRow = this.viewRow.bind(this);
    editRow = this.editRow.bind(this);
    deleteRow = this.deleteRow.bind(this);

    // this component use props
    this.ref = null;
    this.rowClickType = null;
  };

  /**
   *  reactFormatter bug, GroupBtnsMenu -> need before than reactFormatter, and groupMenuTitleFormatter -> need before than reactFormatter
   *  
   ***/
  columns = [
    ...this.state.filterColumns,
    { title: "MAC", field: "MAC", visible: false },
    { title: "Country", field: "countryLong", visible: false },
    { title: "State", field: "stateLong", visible: false },
    { title: "City", field: "cityLong", visible: false },
    { title: "Longitude", field: "longitude", visible: false },
    { title: "Latitude", field: "latitude", visible: false },
    { title: "Labor Warranty", field: "laborWarranty" },
    { title: "Parts Warranty", field: "partsWarranty" },
    { title: "Registered First Date", field: "registeredDate" },
    {
      title: "Status",
      field: "isOnline",
      align: "center",
      formatter: reactFormatter(<OnlineIcon />),
      width: 110
    },
    { title: "", field: "buttonGroup", headerSort:false, formatter: reactFormatter(<GroupBtnsMenu />), 
      titleFormatter: groupMenuTitleFormatter, titleFormatterParams:{tableId : 'hoodList'}}
  ];

  dataLoading = (datas) => {    
    // const { status, reloadPageNumber } = this.props;
    if (this.ref && !this.state.isInitComplete) {
      // if not init and ref has data      
      // step1. init go to page button and change pagination button
      this.refListCommonFooter.initCommonListFooter();

      // step2. init page max label
      const table = this.ref.table;
      updateMaxPageNumber(table);

      // step3. init page buttons
      this.refListCommonFooter.overwritePageBtns();

      // step4. pagination init complete, save into state
      this.setState({
        isInitComplete:true,
        refTable: this.ref.table
      });

      // step5. if has reload table form session, reload it
      const { sessionKey } = this.state;
      const keepTableInfo = getTableInfoFromSession(sessionKey);
      if (keepTableInfo) {
        setTimeout(() => {
          reloadTable(table, keepTableInfo, this.refFilterSearch);
        }, 50);
      }
    }
  }

  reloadList = (e) => {
    const { idToken, initDevicesData, forwardDashboard } = this.props;
    if (idToken) {
      forwardDashboard();
      initDevicesData(idToken);
    }
  }

  viewRow = (props) => {
    this.rowClickType = 'VIEW';
    const { idToken, getDeviceDetail, history } = this.props;
    const { sessionKey, refTable } = this.state;

    if (history) {
      let row = props.cell.getRow();
      let data = row.getData();
      keepTableInfoToSession(sessionKey, refTable, this.refFilterSearch);
      getDeviceDetail(idToken, data.thingName);
      history.push("/HoodList/viewDevice");
    }
  }

  editRow = (props) => {
    this.rowClickType = 'EDIT';
    const { idToken, getDeviceDetail, history } = this.props;
    const { sessionKey, refTable } = this.state;

    if (history) {
      let row = props.cell.getRow();
      let data = row.getData();
      keepTableInfoToSession(sessionKey, refTable, this.refFilterSearch);
      getDeviceDetail(idToken, data.thingName);
      history.push("/HoodList/editDevice");
    }
  }

  deleteRow = (props) => {
    this.rowClickType = 'DELETE';
    const { idToken, removeDevice, devices } = this.props;
    const { sessionKey, refTable } = this.state;

    let check = window.confirm("Really to remove the device?");
    if (check) {
      const row = props.cell.getRow();
      const data = row.getData();
      keepTableInfoToSession(sessionKey, refTable, this.refFilterSearch);
      // do remove
      removeDevice(idToken, data.thingName, devices);
    }  
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { menuMode } = this.props;
    if (prevProps.menuMode !== menuMode) {
      // if menu chagne size(mode), need redraw table
      const { refTable } = this.state;
      refTable.redraw(false);
    }
  }

  render() {
    const paginationSize = this.refListCommonFooter ? this.refListCommonFooter.getPaginationSize() : 50;
    const options = {
      movableRows: false,
      pagination: 'local',
      paginationSize: paginationSize
    };
    const { devices } = this.props;
    const { filterColumns, refTable, quickSearchFilter, visibleColumnsConfig } = this.state;
    const date = new Date();
    const timestamp = moment(date).format('YYYYMMDD');
    const excelFileName = 'Hood List ' + timestamp + '.csv';

    return (
      <div>
        <CommonListFooter tableId={this.tableId} refTable={refTable} refs={(ref) => {this.refListCommonFooter = ref;}} displayPaginationSize={paginationSize}></CommonListFooter>
        <div className='filter-bar'>
          <Row>
            <div className='area-list-title'>
              <div className='list-title'>Hood List</div>
            </div>            
            <div className='area-filter'>
              <FilterSearch filterId='hoodListFilter' refTable={refTable} refColumns={filterColumns} refs={(ref) => {this.refFilterSearch = ref;}}
                quickSearchFilter={quickSearchFilter} title='Search type'
              />
            </div>
            <div className='area-table-tool-bar'>
              <ListSettingBtn tableId={this.tableId} refTable={refTable} refs={(ref) => {this.refTableToolBar = ref;}}
                visibleColumnsConfig={visibleColumnsConfig} defaultColumns={this.columns}>
              </ListSettingBtn>
            </div>
            <div className='area-list-btns' title='Export excel'>
              <span className='area-icon-btn-excel'>
                <ExcelFile filename={ excelFileName } element={<span className='icon-btn-export-excel'/>}>
                    <ExcelSheet data={ devices } name="Devices">
                        <ExcelColumn label="Model Number" value="modelName"/>
                        <ExcelColumn label="Serial Number" value="SN"/>
                        <ExcelColumn label="MAC" value="MAC"/>
                        <ExcelColumn label="Country" value="countryLong"/>
                        <ExcelColumn label="State" value="stateLong"/>
                        <ExcelColumn label="City" value="cityLong"/>
                        <ExcelColumn label="Longitude" value="longitude"/>
                        <ExcelColumn label="Latitude" value="latitude"/>
                        <ExcelColumn label="Labor Warranty" value={(col) => col.laborWarranty ? col.laborWarranty + " " : ""}/>
                        <ExcelColumn label="Parts Warranty" value={(col) => col.partsWarranty ? col.partsWarranty + " " : ""}/>
                        <ExcelColumn label="Registered First Date" value="registeredDate"/>
                        <ExcelColumn label="Status" value={(col) => col.isOnline ? "online" : "offline"}/>
                    </ExcelSheet>
                </ExcelFile>
              </span>
              <span className='area-icon-btn-reload' title='Reload list'><span className='icon-btn-reload' onClick={() => this.reloadList()} /></span>
            </div>
          </Row>
        </div>
        <div className='custom-list-table-area'>
          <ReactTabulator
            ref={ref => (this.ref = ref)}
            columns={this.columns}
            data={devices}
            options={options}
            data-custom-attr="test-custom-attribute"
            className="custom-list-table"
            footerElement={commonListFooter}  // page size default 50
            dataLoading={this.dataLoading}
            renderComplete={this.changePageNumber}
          />
        </div>
      </div>
    )
  };
}

const mapStateToProps = (state, ownProps) => {
  return {
    idToken: state.logindReducers.idToken,
    devices: state.dashboardReducers.devices,
    displayDetail: state.dashboardReducers.displayDetail,
    menuMode: state.menuReducers.displayMode
  }
}

export default withRouter(connect(
  mapStateToProps, 
  { getDeviceDetail, initModalCallback, forwardDashboard, initDevicesData, removeDevice }
)(HoodList))
